import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DialogComponent from "../reusableComponents/Dialog";
import { Link } from "react-router-dom";
import UserRepository from "../../Repository/UserRepository";
import moment from "moment";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import { Button, Grid, MenuItem, Stack, styled } from "@mui/material";
import { Select, TextField, Typography, FormControl } from "@mui/material";
import { Container, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import DateField from "../components/DateField";
import Loader from "../components/Loader";
import ViewIncentives from "./ViewIncentives";
import { IncentivesFeature } from "../features/IncentivesFeature";
import PaySalary from "./PaySalary";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";

const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "12px",
      paddingLeft: "5px",
    },
  },
  cells: {
    style: {
      paddingLeft: "5px",
      fontSize: "12px",
    },
  },
};

const BtnRow = styled(Button)({
  background: "#4EAF51 !important",
  textTransform: "none",
  color: "white",
  borderRadius: "6px",
  margin: "2px",
  height: "30px",
});
const RowBtnPaid = styled(Button)({
  backgroundColor: "#BABABA",
  textTransform: "none",
  color: "white",
  width: "75px",
  margin: "5px",
  borderRadius: "6px",
  "&:hover": {
    backgroundColor: "#BABABA",
  },
});
const DialogTxtFiled = styled(TextField)({
  borderRadius: "6px",
  fontSize: "12px",
  marginTop: " 5px",
  marginBottom: "20px",
});
const Label = styled(Typography)({
  borderRadius: "6px",
  fontSize: "12px",
  marginTop: " 5px",
  marginBottom: "20px",
});

function EmployeeSalary() {
  const [employees, setEmployees] = useState([]);
  console.log('employess', employees);
  const [loading, setLoading] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]);
  const [singleEmployee, setSingleEmployee] = useState("");
  const [selected, setSelected] = useState("");
  const [searchEmployee, setSearchEmployee] = useState({
    title: "",
    date: "",
  });
  const [registerEmployee, setRegisterEmployee] = useState({
    selectedEmployee: "",
    joiningDate: "",
    salary: 0,
  });
  console.log('registerEmployee',registerEmployee);
  const [updateMonthlySalary, setUpdateMonthlySalary] = useState(0);

  const [editGroupSalary, setEditGroupSalary] = useState([]);
  const [updateType, setUpdateType] = useState("increase");
  const [toggledClearRows, setToggleClearRows] = useState(false);

  const [modals, setModals] = useState({
    addSalary: false,
    delete: false,
    editGroupSalary: false,
    groupSalary: false,
    incentive: false,
    editSalary: false,
    groupSalary: false,
    employee: false,
  });
    console.log('modals', modals.employee);
  useEffect(() => {
    getEmployeesList();
    getEmployees();
  }, []);

  const toggle = (name, data) => {
    if (name == "incentive") {
      if (data) {
        setSelected(data);
      }
      setModals((prev) => ({ ...prev, [name]: !prev[name] }));
    } else {
      setModals((prev) => ({ ...prev, [name]: !prev[name] }));
    }
  };

  const columns = [
    {
      name: "#",
      width: "50px",
      selector: (row, index) => index + 1,
    },
    {
      name: "Employee Name",
      cell: (row) => (
        <Link
          to={{
            pathname: "/inventory/admin/salary-history",
            state: {
              row,
            },
          }}
        >
          <h3 style={{ color: "#4EAF50" }}>{row.userName}</h3>
        </Link>
      ),
    },
    {
      name: "Joining Date",
      width: "110px",
      selector: (row) => row.date,
    },
    {
      name: "Total Salary",
      width: "110px",
      selector: (row) => row.currentSalary,
    },

    {
      name: "Salary Paid",
      width: "110px",
      selector: (row) => row.paid,
    },
    {
      name: "Salary Pending",
      selector: (row) => {
        if (row.incentive) {
          return parseFloat(row.remaining) + parseFloat(row?.incentive);
        } else {
          return row.remaining;
        }
      },
    },
    {
      name: "Mark Salary",
      width: "270px",
      cell: (row) => (
        <Stack width="100%" direction="row" alignItems="center" spacing={1}>
          {IncentivesFeature() && (
            <BtnRow
              size="small"
              variant="contained"
              onClick={() => toggle("incentive", row)}
            >
              <Typography sx={{ fontSize: "10px" }}>View Incentives</Typography>
            </BtnRow>
          )}

          {row.currentSalary == row.paid ? (
            <RowBtnPaid size="small" variant="outlined">
              <Typography sx={{ fontSize: "10px" }}>Paid</Typography>
            </RowBtnPaid>
          ) : (
            <BtnRow
              size="small"
              variant="contained"
              onClick={() => {
                toggle("editSalary");
                setSingleEmployee(row);
              }}
            >
              <Typography sx={{ fontSize: "10px" }}>Pay</Typography>
            </BtnRow>
          )}

          <BorderColorIcon
            sx={{ color: "#4eaf51", fontSize: "30px", cursor: "pointer" }}
            onClick={() => {
              toggle("addSalary");
              setSingleEmployee(row);
            }}
          />
          <DeleteForeverIcon
            sx={{ color: "red", fontSize: "35px", cursor: "pointer" }}
            onClick={() => handleDelete(row)}
          />
        </Stack>
      ),
    },
  ];

  const additionalColumn = {
    name: "Incentives",
    selector: (row) => row?.incentive,
  };

  if (IncentivesFeature()) {
    columns.splice(4, 0, additionalColumn);
  }

  const handleDelete = (arg = "") => {
    toggle("delete");
    setSelected(arg);
  };

  const deleteRecord = async () => {
    try {
      setLoading(true);
      handleDelete();
      let { data } = await Repo.salary({
        request: {
          method: "deleteEmployeeSalary",
          data: {
            userId: selected?.userId,
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });

      setLoading(false);
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deleted Successfully");
        getEmployeesList();
      } else {
        Toast("error", "Error");
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const getEmployees = async () => {
    setLoading(true);
    let { data } = await UserRepository.usersModel({
      request: {
        method: "getEmployees",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setEmployees(data.response.data.employees);
    setLoading(false);
  };

  const handleChange = (e) => {
    setRegisterEmployee((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUpdateType = (e) => {
    setUpdateType(e.target.value);
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setSearchEmployee((prev) => ({ ...prev, [name]: value }));
  };
  const handleUpdateSalary = (e) => {
    setUpdateMonthlySalary(e.target.value);
  };

  const AddNewEmployee = async () => {
    const { salary, joiningDate, selectedEmployee, company_code } =
      registerEmployee;
    if (!salary || !joiningDate || !selectedEmployee) {
      Toast("info", "Kindly fill all fields");
      return;
    }
    setLoading(true);
    let { data } = await Repo.salary({
      request: {
        method: "saveSalary",
        data: {
          company_code: selectedEmployee.company_code,
          currentSalary: salary,
          joiningDate: joiningDate,
          userId: selectedEmployee._id,
          userName: selectedEmployee.username,
        },
      },
    });
    setLoading(false);
    
    Toast("success", "Employee Salary Added");
    toggle("employee");
    setRegisterEmployee({ selectedEmployee: "", joiningDate: "", salary: 0 });
    getEmployeesList();
  };

  const getEmployeesList = async () => {
    setLoading(true);
    let { data } = await Repo.salary({
      request: {
        method: "getSalariesByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setAllEmployees(data.response.data.salariesArr);
    setLoading(false);
  };

  const updateEmployeeSalary = async () => {
    let user = singleEmployee.userName || singleEmployee.userName;
    if (!updateMonthlySalary) {
      Toast("info", "Kindly Enter Amount");
      return;
    }
    setLoading(true);
    let { data } = await Repo.salary({
      request: {
        method: "saveSalary",
        data: {
          company_code: singleEmployee.company_code,
          currentSalary: updateMonthlySalary,
          joiningDate: singleEmployee.joiningDate,
          userId: singleEmployee.userId,
          userName: user,
        },
      },
    });
    toggle("addSalary");
    setLoading(false);
    Toast("success", "Salary is Changed");
    getEmployeesList();
    setUpdateMonthlySalary(0);
    setSingleEmployee("");
  };

  const filterEmployees = () => {
    let formattedDate = moment(searchEmployee.date).format("DD-MM-YYYY");

    if (searchEmployee.title && searchEmployee.date) {
      return allEmployees.filter(
        (item) =>
          item?.userName.toLowerCase().includes(searchEmployee.title) &&
          item?.date == formattedDate
      );
    } else if (!searchEmployee.title && searchEmployee.date) {
      return allEmployees.filter((item) => item?.date == formattedDate);
    } else if (searchEmployee.title && !searchEmployee.date) {
      return allEmployees.filter((item) =>
        item?.userName.toLowerCase().includes(searchEmployee.title)
      );
    } else {
      return allEmployees;
    }
  };

  const rowSelection = (data) => {
    setEditGroupSalary(data.selectedRows);
  };

  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  };

  const groupSalary = () => {
    if (!editGroupSalary) {
      Toast("info", "Kindly Select Employees");
      return;
    }
    setLoading(true);
    editGroupSalary.forEach(async (singleEmp) => {
      let { data } = await Repo.salary({
        request: {
          method: "saveSalary",
          data: {
            company_code: singleEmp.company_code,
            currentSalary:
              updateType == "increase"
                ? parseInt(singleEmp.currentSalary) +
                  parseInt(updateMonthlySalary)
                : parseInt(singleEmp.currentSalary) -
                  parseInt(updateMonthlySalary),
            joiningDate: singleEmp.joiningDate,
            userId: singleEmp.userId,
            userName: singleEmp.userName,
          },
        },
      });
    });
    handleClearRows();
    setUpdateType("increase");
    toggle("groupSalary");
    setLoading(false);
    Toast("success", "Group Salary is Changed");
    setUpdateMonthlySalary(0);
    setTimeout(() => {
      getEmployeesList();
    }, 300);
  };

  return (
    <div style={{ marginTop: "50px" }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12} className="ml-n-16">
            <Search
              name={"title"}
              text={"Search..."}
              value={searchEmployee.title}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={5} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Salaries
            </Typography>
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={5} className="ml-n-16">
            <DateField
              name={"date"}
              value={searchEmployee.date}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={1} md={1} xs={3}>
            <ButtonAdd
              variant="contained"
              fullWidth
              onClick={() => toggle("groupSalary")}
            >
              Edit
            </ButtonAdd>
          </Grid>
          <Grid align="center" item lg={1} md={1} xs={3}>
            <ButtonAdd variant="contained" onClick={() => toggle("employee")}>
              Add
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mb: 3 }}>
        {!loading && (
          <DataTable
            columns={columns}
            data={filterEmployees()}
            customStyles={customStyles}
            selectableRows
            onSelectedRowsChange={rowSelection}
            clearSelectedRows={toggledClearRows}
            style={{ marginTop: "40px", backgroundColor: "red" }}
            // pagination
          />
        )}
      </BodyContainer>
      <DialogComponent
        title="Add Employee"
        open={modals.employee}
        onClose={() => toggle("employee")}
        onClickCancel={() => toggle("employee")}
        onClickYes={() => AddNewEmployee()}
        dialogContent={
          <Container>
            <h2 style={{ color: "#4EAF50" }}>Add Employee!</h2>
            <Label variant="body1">Select Employee</Label>
       
            <Select
          
              fullWidth
              variant="outlined"
              value={registerEmployee.selectedEmployee}
              name="selectedEmployee"
              onChange={handleChange}
              label="Employee"
            >
              {employees &&
                employees.map((employee, index) => {
                  return (
                    <MenuItem key={index} value={employee}>
                      {employee.username}
                    </MenuItem>
                  );
                })}
            </Select>

      

            <Label variant="body1">Joining Date</Label>
            <DialogTxtFiled
              fullWidth
              id="date"
              type="date"
              name="joiningDate"
              variant="outlined"
              value={registerEmployee.joiningDate}
              onChange={handleChange}
            />
            <Label variant="body1" style={{ marginTop: "10px" }}>
              Monthly Salary
            </Label>
            <DialogTxtFiled
              fullWidth
              variant="outlined"
              value={registerEmployee.salary}
              name="salary"
              onChange={handleChange}
            />
          </Container>
        }
        buttonAgreeTitle={"Add"}
        buttonDisAgreeTitle={"Cancel"}
      />

      {modals.editSalary && (
        <PaySalary
          open={modals.editSalary}
          onClose={() => toggle("editSalary")}
          item={singleEmployee}
          onSuccess={getEmployeesList}
        />
      )}

      <DialogComponent
        title="Add Salary to Existing Employee"
        open={modals.addSalary}
        onClose={() => toggle("addSalary")}
        onClickCancel={() => toggle("addSalary")}
        onClickYes={() => updateEmployeeSalary()}
        dialogContent={
          <Container>
            <Typography variant="h6" sx={{ mb: 1, color: "#4EAf51" }}>
              Add Employee Salary!
            </Typography>

            <Typography sx={{ textAlign: "left" }} variant="body1">
              Employee Name
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={singleEmployee.userName}
              disabled
              sx={{ borderRadius: "6px", fontSize: "12px", mb: 2 }}
              variant="outlined"
            />
            <Typography sx={{ textAlign: "left" }} variant="body1">
              Joining Date
            </Typography>
            <TextField
              fullWidth
              size="small"
              disabled
              value={singleEmployee.date}
              sx={{ borderRadius: "6px", fontSize: "12px", mb: 2 }}
              variant="outlined"
            />
            <Typography sx={{ textAlign: "left" }} variant="body1">
              Monthly Salary
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{ borderRadius: "6px", fontSize: "12px", mb: 2 }}
              variant="outlined"
              value={singleEmployee.currentSalary}
              disabled
            />
            <Typography sx={{ textAlign: "left" }} variant="body1">
              Update Salary
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{ borderRadius: "6px", fontSize: "12px", mb: 2 }}
              variant="outlined"
              value={updateMonthlySalary}
              onChange={handleUpdateSalary}
            />
          </Container>
        }
        buttonAgreeTitle={"Add"}
        buttonDisAgreeTitle={"Cancel"}
      />
      <DialogComponent
        title="Edit Group Salary"
        open={modals.groupSalary}
        onClose={() => toggle("groupSalary")}
        onClickCancel={() => toggle("groupSalary")}
        onClickYes={() => groupSalary()}
        dialogContent={
          <Container>
            <h2 style={{ color: "#4EAF50" }}>Multiple Employee Salary!</h2>

            <FormControl fullWidth>
              <Label variant="body1">Employees</Label>
              <Select
                style={{ marginTop: "5px", marginBottom: "10px" }}
                label="Employees"
                variant="outlined"
              >
                {editGroupSalary.map((item) => {
                  return <MenuItem value={item._id}>{item.userName}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="Salary"
                name="salary"
                value={updateType}
                onChange={handleUpdateType}
              >
                <FormControlLabel
                  value="increase"
                  control={<Radio />}
                  label="Increase"
                />
                <FormControlLabel
                  value="decrease"
                  control={<Radio />}
                  label="Decrease"
                />
              </RadioGroup>
            </FormControl>
            <Label variant="body1">Update Salary</Label>
            <DialogTxtFiled
              fullWidth
              variant="outlined"
              value={updateMonthlySalary}
              onChange={handleUpdateSalary}
            />
          </Container>
        }
        buttonAgreeTitle={"Add"}
        buttonDisAgreeTitle={"Cancel"}
      />
      {modals.incentiveModal && (
        <ViewIncentives
          open={modals.incentiveModal}
          onClose={() => toggle("incentive")}
          user={selected}
          onClear={getEmployeesList}
        />
      )}
      <DeleteDialog
        title="Delete Salary"
        open={modals.delete}
        onClose={handleDelete}
        onClickYes={deleteRecord}
      />
      <Loader loading={loading} />
    </div>
  );
}

export default EmployeeSalary;
